import { COMPONENTS } from "./constants";
/* eslint-disable-next-line import/prefer-default-export */
export var getIcon = function getIcon(state) {
  return COMPONENTS[state];
};